import { Done } from "@material-ui/icons";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router";
import prefs from "../../../config/prefs";
import { getInfo } from "../../../utils/hooks";
import { getRedirection } from "../../../utils/widgets";
import "./Prefer.scss";

function Prefer() {
    const [selectedIntent, setSelectedIntent] = useState<
        "writer" | "critic" | "producer" | "platform"
    >("writer");
    const [error, setError] = useState("");
    const [loggedIn, setLoggedIn] = useState(true);
    const [updated, setUpdated] = useState(false);

    useEffect(() => {
        if (Cookies.get("token") === undefined) {
            setLoggedIn(false);
        }
    }, []);

    function handleNext(e: any) {
        e.preventDefault();
        console.log("next");
        if (!selectedIntent) {
            setError("Please select an intent to proceed.");
        } else {
            const info = getInfo();
            if (!info) return;
            info.intent = selectedIntent;
            Cookies.set("info", JSON.stringify(info));
            setUpdated(true);
        }
    }
    function handleSelect(value: any) {
        setSelectedIntent(value);
    }

    const selected = prefs.data.intents.find((i) => i.value === selectedIntent);

    return loggedIn ? (
        updated ? (
            getRedirection()
        ) : (
            <div className="intent">
                <h3>Hey there! Tell us who you are</h3>
                <div className="intent__list">
                    {prefs.data.intents.map((intent) => {
                        return (
                            <div
                                className="intent__item"
                                style={{
                                    border:
                                        selectedIntent === intent.value
                                            ? `5px solid rgba(${intent.color}, 0.27)`
                                            : "none",
                                }}
                                onClick={() => handleSelect(intent.value)}
                            >
                                <p style={{ fontWeight: "bold" }}>
                                    {intent.name}
                                </p>
                                <img
                                    src={intent.icon}
                                    className="intent__img"
                                />
                                <div style={{ height: 100 }}></div>
                                <p>{intent.desc}</p>
                            </div>
                        );
                    })}
                </div>
                <div
                    className="info_wrap"
                    style={{
                        backgroundColor: `rgba(${selected?.color}, 0.05)`,
                    }}
                >
                    <h5>As a {selected?.name} on Pencil, you can:</h5>
                    <ul>
                        {selected?.features.map((feature, idx) => (
                            <li key={idx}>
                                <Done
                                    style={{ fill: `rgb(${selected?.color})` }}
                                />{" "}
                                {feature}
                            </li>
                        ))}
                    </ul>
                </div>
                <button className="intent__next" onClick={handleNext}>
                    Proceed as {selected?.name}
                </button>
                <p style={{ color: "red" }}>{error}</p>
            </div>
        )
    ) : (
        <Redirect to="/login" />
    );
}

export default Prefer;
